import React, { PureComponent } from 'react'
import Slider from 'react-slick'
import c from 'classnames'

import { NextArrow, PrevArrow } from 'components/ui/SliderArrows'

import LayoutWindow from 'mixins/LayoutWindow'

import './style'
import './media'

@LayoutWindow
class AnswersSlider extends PureComponent {
    SETTINGS = {
        slidesToShow: 1,
        // variableWidth: true,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        speed: 350,
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        touchMove: true,
        // focusOnSelect: true,
        centerMode: false,
        swipeToSlide: true,
        infinite: false
    }

    render() {
        const { width, list = [] } = this.props

        let settingsSlider = { ...this.SETTINGS }

        settingsSlider = {
            ...settingsSlider,
            slidesToShow: list.length < 3 ? list.length : 3
        }

        if (width <= 1400) {
            settingsSlider = {
                ...settingsSlider,
                slidesToShow: 2,
                centerMode: false,
            }

            if (list.length === 1) {
                settingsSlider = {
                    ...settingsSlider,
                    slidesToShow: 1,
                    dots: true,
                }
            } else if (list.length > 2) {
                settingsSlider = {
                    ...settingsSlider,
                    slidesToShow: 1,
                    dots: true
                }
            }
        }
        
        if (width <= 1000) {
            settingsSlider = {
                ...settingsSlider,
                dots: true,
                slidesToShow: 1,
                centerMode: false,
            }
        }

        if (width <= 700) {
            settingsSlider = {
                ...settingsSlider,
                arrows: false,
            }
        }

        // const showGradient = settingsSlider.slidesToShow < list.length

        return (
            <div className={c("slider-wrapper doctor-answers-slider answers-slider-v2", `count_${list.length}`)}>
                <div className={c("slick-slider-wrapper")}>
                    <Slider
                        {...settingsSlider}
                    >
                        {list}
                    </Slider>
                </div>
            </div>
        );
    }
}

export default AnswersSlider